var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 260,
    viewBox: "0 0 320 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1101",
    "data-name": "Trazado 1101",
    d: "M0,0H320V260H0Z",
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1623",
    "data-name": "Grupo 1623",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_1",
    "data-name": "Enmascarar grupo 1",
    transform: "translate(0 0.002)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1031",
    "data-name": "Trazado 1031",
    d: "M21.762,258.756S-1.916,216.342.125,175.092c3.068-62.023,25.6-83.524,53.914-99.109,22.9-12.606,36.427-31.6,70.489-57.482C168.9-15.213,287.5-11.4,286.641,103.152c-.336,44.592,47.713,77.753,13.2,155.737Z",
    transform: "translate(0 -0.002)",
    fill: "#ffd100",
    opacity: 0.197
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1032",
    "data-name": "Trazado 1032",
    d: "M1175.613,500.969c.836-.244,12.593-.178,12.535.309s-.25,7.294-.354,7.953c.035,1.467-1.868,3.54-6.2,3.642s-6.33-1.877-6.365-3.345c-.178-.742-.733-7.927-.733-7.927Z",
    transform: "translate(-996.475 -425.188)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1033",
    "data-name": "Trazado 1033",
    d: "M1150.522,309.388c-.1-4.394-3.768-13.571-14.393-13.571-11.194,0-14.293,9.676-14.407,13.374-.16,5.181,2.7,9.289,6.147,12.37,1.847,1.648,1.847,5.991,1.847,5.991l13.651-.323s-.315-3.824,1.833-5.839a15.949,15.949,0,0,0,5.321-12",
    transform: "translate(-951.693 -251.138)",
    fill: "#ffd100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1034",
    "data-name": "Trazado 1034",
    d: "M1159.369,395.792l-1.917-.827c-.239-.1-.226-.274.029-.379a1.222,1.222,0,0,1,.825,0l1.074.463a.394.394,0,0,0,.281,0l1.834-.842a.411.411,0,0,1,.269-.01l2.179.776a.411.411,0,0,0,.269-.01l.207-.1a5.368,5.368,0,0,1,3.7-.087l.226.091a.4.4,0,0,0,.264,0l2.3-.9a.4.4,0,0,1,.275,0l1.646.763a.4.4,0,0,0,.276,0l1.384-.568a1.217,1.217,0,0,1,.821,0h0c.238.1.224.272-.03.376l-2.266.931a.4.4,0,0,1-.278,0l-1.667-.772a.4.4,0,0,0-.275,0l-2.237.873a.416.416,0,0,1-.265,0l-.153-.062a5.366,5.366,0,0,0-3.7.087l-.158.073a.4.4,0,0,1-.269.01l-2.18-.777a.4.4,0,0,0-.268.01l-1.911.878a.4.4,0,0,1-.281,0",
    transform: "translate(-981.868 -334.446)",
    fill: "#a21e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1035",
    "data-name": "Trazado 1035",
    d: "M1232.37,409.794a.3.3,0,0,0,.3-.294,33.517,33.517,0,0,1,4.8-18.392.3.3,0,0,0-.509-.3,34.058,34.058,0,0,0-4.885,18.69.3.3,0,0,0,.3.294",
    transform: "translate(-1045.324 -331.66)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1036",
    "data-name": "Trazado 1036",
    d: "M1170.707,409.794a.3.3,0,0,0,.3-.294,34.058,34.058,0,0,0-4.885-18.69.3.3,0,0,0-.509.3,33.517,33.517,0,0,1,4.8,18.392.3.3,0,0,0,.3.294",
    transform: "translate(-988.898 -331.66)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1037",
    "data-name": "Trazado 1037",
    d: "M1184.975,512.886l-12.87.3a.944.944,0,0,1-.968-.92l0-.073a.944.944,0,0,1,.923-.964l12.87-.3a.944.944,0,0,1,.968.92l0,.073a.944.944,0,0,1-.923.965",
    transform: "translate(-993.621 -433.761)",
    fill: "#004666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1038",
    "data-name": "Trazado 1038",
    d: "M1185.352,528.757l-12.87.3a.944.944,0,0,1-.968-.92l0-.073a.944.944,0,0,1,.923-.964l12.87-.3a.944.944,0,0,1,.968.92l0,.073a.944.944,0,0,1-.923.965",
    transform: "translate(-993.942 -447.235)",
    fill: "#004666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1039",
    "data-name": "Trazado 1039",
    d: "M1185.4,544.9l-12.87.3a.945.945,0,0,1-.968-.92l0-.073a.944.944,0,0,1,.923-.964l12.87-.3a.945.945,0,0,1,.968.92l0,.073a.944.944,0,0,1-.923.964",
    transform: "translate(-993.98 -460.94)",
    fill: "#004666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1040",
    "data-name": "Trazado 1040",
    d: "M1625.805,1060.438l-.364,2.3a4.531,4.531,0,0,0,1.581,6.541s1.831,1,2.238-.394.029-.9.651-2.856.194-3.943-1.11-4.77l-.9-1.4Z",
    transform: "translate(-1378.386 -899.785)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1041",
    "data-name": "Trazado 1041",
    d: "M1511.2,769.53c-1.858.244-2.116.066-2.116.066s-5.721-17.048-6.328-18.624-14.976-20.666-14.976-20.666l7.446-15.7s15.032,28.912,16.491,32.934c2.411,6.647,1.922,20.983,1.922,20.983a5.231,5.231,0,0,1-2.439,1",
    transform: "translate(-1262.269 -606.68)",
    fill: "#6b1d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1042",
    "data-name": "Trazado 1042",
    d: "M1656.152,1080.3a9.412,9.412,0,0,0,.739,2.407c.4.549.779,1.034.429,1.3s-1.8-1.178-1.86-1.474a12.911,12.911,0,0,1,.691-2.233",
    transform: "translate(-1404.533 -917.14)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1043",
    "data-name": "Trazado 1043",
    d: "M1557.035,1142.592l-26.287,3.733a6.3,6.3,0,0,1-7.106-5.315l-1.624-11.351a6.283,6.283,0,0,1,5.334-7.082l26.287-3.732a6.3,6.3,0,0,1,7.107,5.315l1.623,11.351a6.283,6.283,0,0,1-5.334,7.082",
    transform: "translate(-1291.267 -949.806)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1044",
    "data-name": "Trazado 1044",
    d: "M1585.241,1116.01l-1.642-11.483a6.321,6.321,0,0,0-7.133-5.335l-9.034,1.283-.35-2.448a2.082,2.082,0,0,0-2.354-1.76l-7.851,1.115a2.079,2.079,0,0,0-1.767,2.346l.35,2.448-5.233.743a6.306,6.306,0,0,0-5.354,7.108l1.642,11.483a6.322,6.322,0,0,0,7.133,5.335l26.241-3.726a6.306,6.306,0,0,0,5.354-7.108m-28.841-16.467a.776.776,0,0,1,.659-.876l7.851-1.115a.777.777,0,0,1,.879.657l.35,2.448-9.39,1.333Z",
    transform: "translate(-1310.656 -930.673)",
    fill: "#004666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1045",
    "data-name": "Trazado 1045",
    d: "M1468.083,646.414s-5.874,4.84-11.594,1.336a18.827,18.827,0,0,1-.333-5.786c.051-.29.1-.571.142-.839.45-2.655.631-4.157.631-4.157h.007c.3-.066,10.111-2.149,10.047-1.84-1.462,7.136,1.1,11.287,1.1,11.287",
    transform: "translate(-1235.335 -539.174)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1046",
    "data-name": "Trazado 1046",
    d: "M1467.24,644.731a14.531,14.531,0,0,1-9.456,4.455c.45-2.655.631-4.157.631-4.157h.006c.265-.022,9.168-.73,8.819-.3",
    transform: "translate(-1236.822 -547.236)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1047",
    "data-name": "Trazado 1047",
    d: "M1444.507,552.542s9.828,4.262,12.4-1.878,5.568-9.725-.6-12.706-8.375-1.148-9.732.694-4.558,12.623-2.068,13.89",
    transform: "translate(-1224.776 -455.369)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1048",
    "data-name": "Trazado 1048",
    d: "M1446.1,524.054c.124.115,2.21,1.191,7.906-6.357a7.33,7.33,0,0,0,.778-6.693c-1.077-2.769-6.148-5.71-10.5-7.378s-5.9.664-7.423,3.014c-1.6,2.466-5.221,4.08-5.221,4.08,3.495,2.868,8.743.619,10.273,1.422s1.639,3.455,1.612,4.294.036,1.552,2.21,1.191.4,3.048-.055,3.68c0,0-.613,1.789.422,2.748",
    transform: "translate(-1214.639 -427.081)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1049",
    "data-name": "Trazado 1049",
    d: "M1624.5,1626.737h6.318c1.325,0,2.8-1.321,3.165-3.741s3.091-3.741,3.68-5.721-2.43-4.769-2.43-4.769l-.5-.646-.525-.673-5,1.173s-.124,1.188-.2,2.7a34.37,34.37,0,0,0-.02,3.462c.148,2.641-.742,5.485-3.1,6s-1.381,2.217-1.381,2.217",
    transform: "translate(-1378.099 -1367.841)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1050",
    "data-name": "Trazado 1050",
    d: "M1335.432,1663.073h16.748a1.511,1.511,0,0,0,.355-.1c1.118-.558.768-4.824.634-6.142-.026-.244-.044-.387-.044-.387s-5.889-4.693-6.7-1.1c-.026.112-.056.222-.087.33v0c-1.022,3.363-5.592,4.89-8.232,5.316-2.017.327-2.54,1.5-2.675,2.083",
    transform: "translate(-1133.015 -1404.176)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1051",
    "data-name": "Trazado 1051",
    d: "M1357.7,1068.3s.894,11.12,1.946,24.485c1.429,18.157,3.147,40.459,3.317,44.684.294,7.336,1.473,19.072,1.473,19.072s2.8,2.788,8.392,1.613a191.431,191.431,0,0,0,6.411-34.478c.022-.29.045-.583.066-.876,1.325-18.044,3.385-56.041,3.385-56.041Z",
    transform: "translate(-1151.91 -905.645)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1052",
    "data-name": "Trazado 1052",
    d: "M1357.7,1068.3s.894,11.12,1.946,24.485l19.593,30.891c.022-.29.045-.583.066-.876,1.325-18.044,3.385-56.041,3.385-56.041Z",
    transform: "translate(-1151.91 -905.645)",
    fill: "#004666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1053",
    "data-name": "Trazado 1053",
    d: "M1384.649,1044.887s16.121,40.27,26.721,59.194,13.913,24.206,13.913,24.206,6.073-2.421,6.625-4.071c0,0-4.054-36.535-11.152-45.441-4.011-5.032-8.723-20.135-8.944-25.416s-1.435-15.734-1.435-15.734Z",
    transform: "translate(-1174.772 -880.907)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1054",
    "data-name": "Trazado 1054",
    d: "M1351.89,751.535a1,1,0,0,0,.646.294c2.361.13,9.155,1.9,15.017,1.7a43.585,43.585,0,0,0,14.193-3.067c.64-.235,2.118-.9,2.133-1.589.03-.756.03-1.859.028-3.247a172.618,172.618,0,0,1,1.187-22.6c.222-1.766.394-3.521.519-5.254a79.893,79.893,0,0,0-.047-12.781c-.669-7.289-2.545-13.117-5.73-15.84-.42-.343-3.215.791-5.786,1.847a10.372,10.372,0,0,1-6.821.361l-2.3,1.764a21.684,21.684,0,0,0-7.532,10.362c-2.382,7.35-4.222,27.161-4.463,30.828-.156.966-1.313,16.98-1.042,17.228",
    transform: "translate(-1146.944 -585.007)",
    fill: "#8d3ea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1055",
    "data-name": "Trazado 1055",
    d: "M1361.993,740.672a66.9,66.9,0,0,1,1.959-8.775,20.824,20.824,0,0,1,6.324-9.342c3.746,1.215,7.719,2.758,9.373,4.25,3.517,3.175,2.971,9.689,2.971,9.689s-8.049,15.308-23.113,25.175c.418-5.142,1.424-14.521,2.485-21",
    transform: "translate(-1153.442 -613.424)",
    fill: "#6b1d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1056",
    "data-name": "Trazado 1056",
    d: "M1172.282,534.813c.082-1.106.23-3.59-.1-3.52a1.381,1.381,0,0,0-.722.758c-.22.909-1.927-.262-2.885-2.769-.546-1.428-.815-2.805-1.027-2.808-.415-.005-1.35,1.178-1.442,3.7s.633,5.411,2.668,6.8l1.371,1.6,3.071-1.539s-.49-1.087-.94-2.221",
    transform: "translate(-989.353 -446.958)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1057",
    "data-name": "Trazado 1057",
    d: "M1187,587.448c1.633-1.139,2.446-.43,2.446-.43s13.554,15.379,14.9,16.569,22.017,5.888,22.017,5.888,8.344,1.548,9.519,6.206c1.02,4.047-.851,6.99-3.128,8.974a8.8,8.8,0,0,1-9.814,1.145c-7.18-3.718-21.438-11.23-23.932-13.517-5.548-5.092-13.9-22.7-13.9-22.7a6.256,6.256,0,0,1,1.886-2.134",
    transform: "translate(-1005.485 -498.173)",
    fill: "#8d3ea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1058",
    "data-name": "Trazado 1058",
    d: "M899.463,806.016c1.095-.919,2.978-2.052,3.086-1.738.077.226-.3.945-.544,1.345a26.14,26.14,0,0,1,4.761.054c.915.115,2.349.337,2.638.776.133.2.24.613-.483,1.149a8.737,8.737,0,0,1-3.216,1.763c-2.866,1.07-5.628.643-7.682.533l-.7-.115-.23-3.035a9.975,9.975,0,0,0,2.371-.734",
    transform: "translate(-761.115 -682.759)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1059",
    "data-name": "Trazado 1059",
    d: "M554.288,641.971s4.927,5.825,11.2,3.388a18.889,18.889,0,0,0,1.369-5.651c0-.3.006-.581.011-.853.033-2.7.125-4.215.125-4.215h-.006c-.286-.119-9.591-3.926-9.583-3.609.16,7.3-3.115,10.942-3.115,10.942",
    transform: "translate(-470.272 -535.706)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1060",
    "data-name": "Trazado 1060",
    d: "M580.97,642.279a14.55,14.55,0,0,0,8.531,6.085c.034-2.7.125-4.215.125-4.215h-.006c-.258-.069-8.916-2.357-8.649-1.868",
    transform: "translate(-492.905 -545.214)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1061",
    "data-name": "Trazado 1061",
    d: "M575.494,556.576s-10.465,2.452-11.9-4.066-3.747-10.591,2.874-12.431,8.47.362,9.479,2.422,2.229,13.27-.456,14.076",
    transform: "translate(-476.824 -457.922)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1062",
    "data-name": "Trazado 1062",
    d: "M543.509,529.82c-.143.091-1.945-1.589-4.726-6.979-.682-1.322-1.56-4.8,0-7.34s5.421-3.562,9.985-4.588c4.083-.918,5.528.083,6.739,2.1,2.255,3.752,0,5.024,0,5.024-2.405,1.251-4.066.259-5.72.777s-2.238,3.117-2.363,3.949-.315,1.525-2.395.781-.94,2.937-.607,3.641c0,0,.283,1.875-.91,2.637",
    transform: "translate(-456.378 -433.456)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1063",
    "data-name": "Trazado 1063",
    d: "M322.653,1626.48h-6.337c-1.328,0-2.8-1.325-3.174-3.752s-3.1-3.752-3.691-5.738,2.437-4.783,2.437-4.783l.506-.648.526-.676,5.02,1.176s.124,1.192.2,2.708a34.468,34.468,0,0,1,.02,3.472c-.148,2.649.745,5.5,3.106,6.016s1.386,2.224,1.386,2.224",
    transform: "translate(-262.481 -1367.584)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1064",
    "data-name": "Trazado 1064",
    d: "M587.551,1662.924h-16.8a1.5,1.5,0,0,1-.357-.1c-1.122-.559-.77-4.838-.636-6.159.026-.245.044-.389.044-.389s5.906-4.707,6.719-1.1c.026.113.055.223.087.331v0c1.025,3.373,5.609,4.9,8.256,5.331,2.023.328,2.548,1.5,2.683,2.089",
    transform: "translate(-483.265 -1404.027)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1065",
    "data-name": "Trazado 1065",
    d: "M525.393,1066.4s-.9,11.152-1.951,24.557c-1.433,18.21-3.156,40.578-3.327,44.816-.295,7.358-1.477,19.128-1.477,19.128s-2.8,2.8-8.417,1.618a191.953,191.953,0,0,1-6.43-34.579c-.022-.291-.044-.585-.067-.878-1.329-18.1-3.4-56.206-3.4-56.206Z",
    transform: "translate(-424.493 -904.028)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1066",
    "data-name": "Trazado 1066",
    d: "M525.393,1066.4s-.9,11.152-1.951,24.557l-19.65,30.982c-.022-.291-.044-.585-.067-.878-1.329-18.1-3.4-56.206-3.4-56.206Z",
    transform: "translate(-424.493 -904.028)",
    fill: "#004666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1067",
    "data-name": "Trazado 1067",
    d: "M373.349,1042.917s-16.169,40.388-26.8,59.369-13.954,24.277-13.954,24.277-6.091-2.427-6.645-4.083c0,0,4.065-36.642,11.185-45.575,4.023-5.047,8.749-20.194,8.97-25.491s1.44-15.78,1.44-15.78Z",
    transform: "translate(-276.545 -879.217)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1068",
    "data-name": "Trazado 1068",
    d: "M584.272,747.722c-.172-1.865-.4-2.077-.4-2.077s-18-1.8-19.684-2.044-23.6-10.021-23.6-10.021l-13.759,10.733s31.711,8.249,35.983,8.78c7.059.878,21.024-2.773,21.024-2.773a5.2,5.2,0,0,0,.443-2.6",
    transform: "translate(-446.969 -622.784)",
    fill: "#670a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1069",
    "data-name": "Trazado 1069",
    d: "M494.436,710.783c-.063,3.453-.264,7.336-.536,11.279-.49,6.941-.99,11.857-1.007,12.008-.883,8.943-1.809,16.009-1.981,16.117a1.009,1.009,0,0,1-.689.175c-2.354-.295-9.376.238-15.125-1.009a43.678,43.678,0,0,1-13.455-5.56c-.587-.346-1.927-1.263-1.818-1.948.107-.753.3-1.841.556-3.209a173.051,173.051,0,0,0,2.891-22.516q.15-2.676.434-5.278a79.822,79.822,0,0,1,2.345-12.6c1.971-7.073,6.141-12.371,9.775-14.49.475-.265,1.757,1.237,4.1,2.738,2.167,1.384,4.221.753,6.44.56l2.18,3.166c5.775,6.689,6.044,11.731,5.886,20.571",
    transform: "translate(-390.122 -580.453)",
    fill: "#a21e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1070",
    "data-name": "Trazado 1070",
    d: "M624.659,750.036c-.063,3.453-.264,7.336-.536,11.279q-.025.351-.05.7c-13.444-8.385-10.492-32.062-10.492-32.062,5.737,2.206,9.5,7.81,10.414,9.176.19,2.112.717,7.912.663,10.906",
    transform: "translate(-520.345 -619.705)",
    fill: "#670a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1071",
    "data-name": "Trazado 1071",
    d: "M902.144,883.77c.911-.641,2.978-2.052,3.085-1.737.078.226-.3.945-.544,1.345a26.145,26.145,0,0,1,4.761.054c.915.115,2.349.337,2.638.776.133.2.24.613-.483,1.15a8.742,8.742,0,0,1-3.216,1.762c-2.866,1.07-5.628.642-7.682.533l-.7-.115-.259-3.425s1.191-.141,2.4-.343",
    transform: "translate(-763.365 -748.776)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1072",
    "data-name": "Trazado 1072",
    d: "M599.537,752.187c.139-1.987-.894-2.317-.894-2.317s-20.27-3.66-21.993-4.2-16.458-15.814-16.458-15.814-5.648-6.347-10.272-4.945c-4.018,1.218-5.589,4.341-6.124,7.317a8.754,8.754,0,0,0,4.085,9c6.917,4.228,20.766,12.558,24.028,13.511,7.259,2.121,26.763.17,26.763.17a6.254,6.254,0,0,0,.866-2.718",
    transform: "translate(-461.255 -615.252)",
    fill: "#a21e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1073",
    "data-name": "Trazado 1073",
    d: "M1209.124,139.711a.357.357,0,0,1-.353-.3,54.792,54.792,0,0,1,.645-16.647.357.357,0,0,1,.7.135,53.976,53.976,0,0,0-.64,16.406.358.358,0,0,1-.354.409",
    transform: "translate(-1025.255 -103.975)",
    fill: "#ffd100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1074",
    "data-name": "Trazado 1074",
    d: "M1041.52,229.262a.358.358,0,0,1-.3-.161c-.036-.055-3.715-5.564-12.129-11.452a.356.356,0,1,1,.411-.583c8.536,5.973,12.28,11.588,12.316,11.644a.356.356,0,0,1-.3.551",
    transform: "translate(-872.979 -184.227)",
    fill: "#ffd100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1075",
    "data-name": "Trazado 1075",
    d: "M1319.342,213.4a.356.356,0,0,1-.176-.667c.072-.04,7.22-4.1,9.855-10.183a.357.357,0,0,1,.656.282c-2.733,6.307-9.859,10.353-10.161,10.522a.357.357,0,0,1-.175.046",
    transform: "translate(-1119.061 -171.777)",
    fill: "#ffd100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1076",
    "data-name": "Trazado 1076",
    d: "M1370.171,366.423a.349.349,0,0,1-.066-.006c-2.224-.416-16.65,0-16.795.006a.356.356,0,1,1-.021-.712c.6-.018,14.648-.423,16.948.006a.356.356,0,0,1-.066.706",
    transform: "translate(-1147.871 -310.314)",
    fill: "#ffd100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1077",
    "data-name": "Trazado 1077",
    d: "M979.762,391.384a.356.356,0,0,1-.1-.7,68.68,68.68,0,0,1,16.83-2.381.356.356,0,1,1,0,.712,67.91,67.91,0,0,0-16.627,2.351.357.357,0,0,1-.1.015",
    transform: "translate(-830.952 -329.658)",
    fill: "#ffd100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1078",
    "data-name": "Trazado 1078",
    d: "M320.061,1714.316H1.46a.635.635,0,1,1,0-1.269h318.6a.637.637,0,0,1,.637.635h0a.637.637,0,0,1-.637.634",
    transform: "translate(-0.698 -1454.316)",
    fill: "#2e3552"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo);
export default __webpack_public_path__ + "static/media/grupo.c7b2aeceda79cb1ad2e03ad0740dfd49.svg";
export { ForwardRef as ReactComponent };